var map = {
	"./icons": 68,
	"./icons.jsx": 68,
	"./icons/add_blue.svg": 862,
	"./icons/avatar.svg": 863,
	"./icons/calendar.svg": 864,
	"./icons/chevron-back-white.svg": 865,
	"./icons/chevron-forward-white.svg": 866,
	"./icons/close-outline.svg": 867,
	"./icons/course.svg": 868,
	"./icons/eye-off-white.svg": 869,
	"./icons/eye.svg": 870,
	"./icons/generic-error.svg": 871,
	"./icons/help.svg": 872,
	"./icons/inventory.svg": 873,
	"./icons/lock.svg": 874,
	"./icons/logout.svg": 875,
	"./icons/marketing.svg": 876,
	"./icons/pos.svg": 877,
	"./icons/reports.svg": 878,
	"./icons/schedule.svg": 879,
	"./icons/search.svg": 880,
	"./icons/settings.svg": 881,
	"./icons/zoom-in.svg": 882,
	"./icons/zoom-out.svg": 883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 861;